import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterModule} from '../footer/footer.module'
import {SendRequestActionsComponent} from './send-request-actions.component';
import { BannerModule } from '@xref/xref-lib';
import { ButtonModule } from '@xref/xref-lib';
@NgModule({
  declarations: [SendRequestActionsComponent],
  imports: [
    CommonModule,
    FooterModule,
    BannerModule,
    ButtonModule
  ],
  exports: [SendRequestActionsComponent]
})
export class SendRequestActionsModule {
}
